<!--
  FieldTaskSortOrder.vue
  Sort-order cell for the course tasks (StructuredPlan) list.
  Unlike FieldSortOrder (lessons), the backend derives SortOrder from each id's
  POSITION in the list, so we move the row within `items` and send the full
  ordered id list to PUT /StructuredPlan/Tasks/Reorder.
-->
<template>
  <div class="Field__Component">
    <template v-if="isLoading">
      <div class="loading">
        <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false" />
      </div>
    </template>
    <div>
      <b-tooltip label="הזז למטה (מאוחר יותר באותו יום)" position="is-top">
        <span style="padding: 5px" @click.stop="move(1)">
          <b-icon size="is-small" icon="arrow-down" class="sort__order__button" />
        </span>
      </b-tooltip>
      <slot class="sort__order__value">{{ value }}</slot>
      <b-tooltip label="הזז למעלה (מוקדם יותר באותו יום)" position="is-top">
        <span style="padding: 5px" @click.stop="move(-1)">
          <b-icon size="is-small" icon="arrow-up" class="sort__order__button" />
        </span>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import TasksService from "../../services/TasksService";

export default {
  name: "FieldTaskSortOrder",
  props: ["value", "item", "search"],
  data() {
    return { isLoading: false };
  },
  methods: {
    // direction: -1 = up, 1 = down. The server moves the task within its day.
    move(direction) {
      this.isLoading = true;
      TasksService.moveStructuredPlanTask(this.item.id, direction)
        .then(() => this.search())
        .finally(() => { this.isLoading = false; });
    },
  },
};
</script>

<style scoped lang="scss">
.sort__order__button {
  padding: 5px;
  background-color: #1eb2d0;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  height: 17px;
  width: 17px;
}
.sort__order__value {
  width: 15px;
  margin: 0 10px;
  display: inline-block;
  text-align: center;
}
</style>
